module.exports = __webpack_public_path__ + "img/circuit-line-short.8fd17ede.svg";